import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, distinctUntilChanged, ReplaySubject, takeUntil } from 'rxjs';

import { CategoryModel } from '../../sign-up/models/sign-up.model';
import { ApiService } from '../../sign-up/services/api.service';
import { ActivatedRoute } from "@angular/router";
import { LocaleService } from "../../../locale/locale.service";

@Component({
  selector: 'app-lexicon-list',
  templateUrl: './lexicon-list.component.html',
  styleUrls: [
    './styles/lexicon-list.component.scss',
    './styles/lexicon-list-desktop.scss',
    './styles/lexicon-list-tablet.scss',
    './styles/lexicon-list-mobile.scss',
  ]
})
export class LexiconListComponent implements OnInit, OnDestroy {

  public selectedCategory: number = 0;
  public category: { [key: number]: CategoryModel } = {};

  public categoryList = [
    {
      id: 0,
      label: 'MAIN.ALL_CATEGORIES',
      icon: '',
    },
  ];

  public basicCategory = [
    {
      id: 0,
      label: 'MAIN.ALL_CATEGORIES',
      icon: '',
    },
  ]
  public selectCategoryControl: FormControl = new FormControl(this.basicCategory[0]);

  public lexiconListNav$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public selectedFilter: string = '';
  public lexiconList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public lexiconListData: {[key: string]: any[]} = {};

  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public apiService: ApiService,
    private route: ActivatedRoute,
    private localeService: LocaleService,
  ) {
  }

  ngOnInit() {
    this.localeService.currentLocalePrefix$
      .pipe(
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.getLexiconList();
      });
  }

  public getLexiconList(): void {
    this.apiService.getLexiconList()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.lexiconListData = data;
        this.getLexiconListNav(data);
        this.prepareLexiconList();
        this.getActiveCategoriesList(data.category);
      })
  }

  public getActiveCategoriesList(category: {[key: number]: CategoryModel }): void {
    this.categoryList = this.basicCategory;

    for (const key in category) {
      if (category.hasOwnProperty(key)) {
        this.categoryList = [
          ...this.categoryList, {
            id: +key,
            label: category[key].name,
            icon: category[key].icon,
          }
        ];
      }
    }
  }

  public selectCategory(categoryId: number): void {
    this.selectedCategory = categoryId;
    if (categoryId !== 0) {
      this.getLexiconListByCategory();
    } else {
      this.getLexiconList();
    }
  }

  public getLexiconListByCategory(): void {
    this.apiService.getLexiconListByCategory(+this.selectedCategory)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        // this.getActiveCategoriesList(response.category);
        this.lexiconListData = response;
        this.prepareLexiconList();
        this.getLexiconListNav(response);
      });
  }

  public getLexiconListNav(lexicon: {[key: string]: any[] }): void {
    this.lexiconListNav$.next([]);

    for (const key in lexicon) {
      if (lexicon.hasOwnProperty(key)) {
        this.lexiconListNav$.next([
          ...this.lexiconListNav$.value,
          {
            title: key,
            isOpen: true
          }
        ]);
      }
    }
  }

  public clearFilter(): void {
    this.selectedFilter = '';
    this.prepareLexiconList();
  }

  public selectFilter(filter: string): void {
    this.selectedFilter = filter;
    this.prepareLexiconList(filter);
  }

  public prepareLexiconList(filter?: string): void {
    let lexiconData: any[] = [];

    if (!filter) {
      for (const key in this.lexiconListData) {
        if (this.lexiconListData.hasOwnProperty(key)) {
          lexiconData = [
            ...lexiconData,
            {
              title: key,
              isOpen: false,
              data: this.lexiconListData[key]
            }
          ];
        }
      }
    } else {
      lexiconData = [{
        title: filter,
        isOpen: true,
        data: this.lexiconListData[filter]
      }];
    }

    if (lexiconData.length) {
      lexiconData[0].isOpen = true;
    }

    this.lexiconList$.next(lexiconData);
  }

  public openPanel(index: number) {
    this.lexiconList$.value[index].isOpen = !this.lexiconList$.value[index].isOpen;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
